const copyString = (event: React.MouseEvent<HTMLButtonElement>) => {
	const target = event.target as HTMLButtonElement;
	navigator.clipboard.writeText(target.value);

	return target.value;
};

export default copyString;
